import { Form, Input } from 'decorator-form';

import { IBreakpoint } from 'common/form/fields/BreakpointsField';
import InputType from 'common/form/InputType';

@Form({title: "Carousel Container Config"})
export default class CarouselConfig {

	@Input({type: InputType.CHECKBOX, title: "Auto Play"})
	public autoplay: boolean = false;

	@Input({type: InputType.NUMBER, title: "Auto Play Speed"})
	public autoplaySpeed: number;

	@Input({type: InputType.NUMBER, title: "Animation Speed"})
	public speed: number;

	@Input({type: InputType.CHECKBOX, title: "Arrows"})
	public arrows: boolean = true;

	@Input({type: InputType.COLOR, title: "Arrow Color"})
	public arrowColor: string;

	@Input({type: InputType.NUMBER, title: "Arrow Size"})
	public arrowSize: number;



	@Input({type: InputType.CHECKBOX, title: "Infinite Scrolling"})
	public infinite: boolean = false;

	@Input({type: InputType.CHECKBOX, title: "Fade Transition"})
	public fade: boolean = false;

	@Input({type: InputType.NUMBER, title: "Maximum Slides to Show"})
	public slidesToShow: number = 3;

	@Input({type: InputType.NUMBER, title: "Default Slides to Scroll"})
	public slidesToScroll: number = 3;

	@Input({type: InputType.MARGIN, title: "Margin"})
	public margin?: string;

	@Input({type: InputType.NUMBER, title: "Minimum Slide Width"})
	public minSlideWidth: number;

	// slides

	@Input({type: InputType.NUMBER, title: "Spacing Between Slides"})
	public slideSpacing: number = 10;

	@Input({type: InputType.NUMBER, title: "Default sleleton items (after the 1st render this is saved"})
	public defaultSkeletonCount?: number = 6;


	// dots

	@Input({type: InputType.CHECKBOX, title: "Dots"})
	public dots: boolean = false;

	@Input({type: InputType.COLOR, title: "Dots Color"})
	public dotsColor: string;

	@Input({type: InputType.COLOR, title: "Dots Active Color"})
	public dotsActiveColor: string;

	@Input({type: InputType.NUMBER, title: "Dots Size"})
	public dotsSize: number;

	@Input({type: InputType.MARGIN, title: "Dots Margin"})
	public dotsMargin?: string;

}



// WEBPACK FOOTER //
// ./src/common/views/carousel/CarouselConfig.ts